import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-choose-table',
  templateUrl: './choose-table.component.html',
  styleUrls: ['./choose-table.component.css']
})
export class ChooseTableComponent implements OnInit {

  model = { 'dialog_type': 'select_table', 'serv_table_id': '' };
  table_list = [];

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private dialogRef: MatDialogRef<ChooseTableComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

  }

  ngOnInit() {
    if (this.dialog_data['dialog_type'] != undefined)
      this.model.dialog_type = this.dialog_data['dialog_type'];

    if (this.dialog_data['serv_table_id'] != undefined)
      this.model.serv_table_id = this.dialog_data['serv_table_id'];

    let query = this.queryList.all_serv_table;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let tables = data.data['list'];
        let index = 0;
        let col_num = 3;
        let row_obj;

        let tables_len = tables.length;
        if (tables_len == 4)
          col_num = 2;
        else if (tables_len > 6 && tables_len <= 8) // make number of item in row = 4
          col_num = 4;
        else if (tables_len > 8 && tables_len <= 10)
          col_num = 5;
        else if (tables_len > 10)
          col_num = 6;

        tables.forEach(element => {
          if (index % col_num == 0) {
            row_obj = { 'row_index': this.table_list.length, 'col_list': [] };
            this.table_list.push(row_obj); 
          }
          
          element['disabled'] = false; 
          if (element.serv_table_id == this.model.serv_table_id)
              element['class'] = 'myTablebutton';
          else {
            if (element.res_status == '1') 
              element['class'] = 'tablebutton';
            else if (element.res_status == '2') {
              element['disabled'] = (this.model['dialog_type'] == 'select_table' ? true : false);
              element['class'] = 'busyTablebutton';
            } 
          }    
            
          row_obj.col_list.push(element);
          index++;
        });

      });
  }

  selectTable(table) {
    
    this.dialog_data['serv_table_id'] = table.serv_table_id;
    this.dialog_data['table_number'] = table.table_number;
    this.dialog_data['qutation_no'] = table.qutation_no;
    this.cancel();
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
